import { connect } from "react-redux";
import {
  AddAgentsDTO,
  ConnectOzonetelDTO,
  IntegrationsInitialStateDTO,
} from "../service/types";
import {
  addOzonetelAgents,
  callLead,
  connectOzonetel,
  deactivateOzonetel,
  getAppsByInstitute,
  validateAgentId,
} from "../service/IntegrationsSlice";
import OzonetelStages from "../components/OzonetelDetails/OzonetelStages";
import { RootState, TypedDispatch } from "../../../../redux/store";
import { getStaffList } from "../../Manage/ManageStaff/service/Staffslice";
import { getInstituteById } from "../../Manage/InstituteProfile/service/instituteSlice";

interface DispatchProps {
  ConnectOzonetel(data: ConnectOzonetelDTO): void;
  GetStaffList(id: string): void;
  GetInstituteById(id: string): void;
  DeactivateOzonetel(id: string): void;
  ValidateAgentId(data: any): void;
  GetAppsByInstitute(id: string): void;
  AddOzonetelAgents(data: AddAgentsDTO): void;
  CallLead(data: any): void;
}

const mapStateToProps = (state: RootState): IntegrationsInitialStateDTO => {
  return {
    appsList: state.appIntegrations.appsList,
    validatedAgent: state.appIntegrations.validatedAgent,
    error: state.appIntegrations.error,
    success: state.appIntegrations.success,
    loading: state.appIntegrations.loading,
    ozonetelConnectError: state.appIntegrations.ozonetelConnectError,
    ozonetelConnectLoading: state.appIntegrations.ozonetelConnectLoading,
    ozonetelConnectSuccess: state.appIntegrations.ozonetelConnectSuccess,
    deactivateOzonetelError: state.appIntegrations.deactivateOzonetelError,
    deactivateOzonetelLoading: state.appIntegrations.deactivateOzonetelLoading,
    deactivateOzonetelSuccess: state.appIntegrations.deactivateOzonetelSuccess,
    agentAddedError: state.appIntegrations.agentAddedError,
    agentAddedLoading: state.appIntegrations.agentAddedLoading,
    agentAddedSuccess: state.appIntegrations.agentAddedSuccess,
    validateAgentError: state.appIntegrations.validateAgentError,
    validateAgentLoading: state.appIntegrations.validateAgentLoading,
    validateAgentSuccess: state.appIntegrations.validateAgentSuccess,
    agentUpdatedError: state.appIntegrations.agentUpdatedError,
    agentUpdatedLoading: state.appIntegrations.agentUpdatedLoading,
    agentUpdatedSuccess: state.appIntegrations.agentUpdatedSuccess,
    callLeadError: state.appIntegrations.callLeadError,
    callLeadLoading: state.appIntegrations.callLeadLoading,
    callLeadSuccess: state.appIntegrations.callLeadSuccess,
    nurturePayInstalledError: state.appIntegrations.nurturePayInstalledError,
    nurturePayInstalledLoading:
      state.appIntegrations.nurturePayInstalledLoading,
    nurturePayInstalledSuccess:
      state.appIntegrations.nurturePayInstalledSuccess,
    ozonetelWidgetShow: state.appIntegrations.ozonetelWidgetShow,
    callDispositionError: state.appIntegrations.callDispositionError,
    callDispositionLoading: state.appIntegrations.callDispositionLoading,
    callDispositionSuccess: state.appIntegrations.callDispositionSuccess,
    appTokenLoading: state.appIntegrations.appTokenLoading,
    appTokenSuccess: state.appIntegrations.appTokenSuccess,
    appTokenError: state.appIntegrations.appTokenError,
    appTokenData: state.appIntegrations.appTokenData,
    appTokenGetLoading: state.appIntegrations.appTokenGetLoading,
    appIntegrationloading: state.appIntegrations.appIntegrationloading,
    appIntegrationError: state.appIntegrations.appIntegrationError,
    appIntegrationSuccess: state.appIntegrations.appIntegrationSuccess,
    uninstallLoading: state.appIntegrations.uninstallLoading,
    uninstallSuccess: state.appIntegrations.uninstallSuccess,
    uninstallError: state.appIntegrations.uninstallError,

    addAccountLoading: state.appIntegrations.addAccountLoading,
    addAccountSuccess: state.appIntegrations.addAccountSuccess,
    addStreamLoading: state.appIntegrations.addStreamLoading,
    addStreamSuccess: state.appIntegrations.addStreamSuccess,
    metaAccountsLoading: state.appIntegrations.metaAccountsLoading,
    metaPagesLoading: state.appIntegrations.metaPagesLoading,
    metaAdsLoading: state.appIntegrations.metaAdsLoading,
    metaFormsLoading: state.appIntegrations.metaFormsLoading,
    metaAccounts: state.appIntegrations.metaAccounts,
    metaPages: state.appIntegrations.metaPages,
    metaAds: state.appIntegrations.metaAds,
    metaForms: state.appIntegrations.metaForms,
    streamsLoading: state.appIntegrations.streamsLoading,
    metaStreams: state.appIntegrations.metaStreams,
    createdStreamId: state.appIntegrations.createdStreamId,
    streamLoading: state.appIntegrations.streamLoading,
    metaStream: state.appIntegrations.metaStream,
    metaFieldsLoading: state.appIntegrations.metaFieldsLoading,
    metaFields: state.appIntegrations.metaFields,
    metaDefaultFieldsLoading: state.appIntegrations.metaDefaultFieldsLoading,
    metaDefaultFields: state.appIntegrations.metaDefaultFields,
    metaFieldMapLoading: state.appIntegrations.metaFieldMapLoading,
    metaFieldMapSuccess: state.appIntegrations.metaFieldMapSuccess,
    editStreamSuccess: state.appIntegrations.editStreamSuccess,
    editStreamLoading: state.appIntegrations.editStreamLoading,
    editMetaFieldMapSuccess: state.appIntegrations.editMetaFieldMapSuccess,
    editMetaFieldMapLoading: state.appIntegrations.editMetaFieldMapLoading,

    metaAddonPaymentLinkLoading:
      state.appIntegrations.metaAddonPaymentLinkLoading,
    metaAddonPaymentLink: state.appIntegrations.metaAddonPaymentLink,
    metaAddonPaymentLinkSuccess:
      state.appIntegrations.metaAddonPaymentLinkSuccess,
    metaAddonPaymentLinkError: state.appIntegrations.metaAddonPaymentLinkError,
    metaCreditDitribution: state.appIntegrations.metaCreditDitribution,
    metaCreditDitributionLoading:
      state.appIntegrations.metaCreditDitributionLoading,
    metaCreditDitributionSuccess:
      state.appIntegrations.metaCreditDitributionSuccess,

    editCeditData: state.appIntegrations.editCeditData,
    editCreditDataLoading: state.appIntegrations.editCreditDataLoading,
    editCreditDataSuccess: state.appIntegrations.editCreditDataSuccess,
    streamByIdLoading: state.appIntegrations.streamByIdLoading,
    streamById: state.appIntegrations.streamById,
    streamByIdSuccess: state.appIntegrations.streamByIdSuccess,

    metaStreamsForBranch: state.appIntegrations.metaStreamsForBranch,
    streamsForBranchLoading: state.appIntegrations.streamsForBranchLoading,
    streamsForBranchSuccess: state.appIntegrations.streamsForBranchSuccess,

    metaContactList: state.appIntegrations.metaContactList,
    metaContactListLoading: state.appIntegrations.metaContactListLoading,
    metaContactListSuccess: state.appIntegrations.metaContactListSuccess,

    metaContactToLead: state.appIntegrations.metaContactToLead,
    metaContactToLeadLoading: state.appIntegrations.metaContactToLeadLoading,
    metaContactToLeadSuccess: state.appIntegrations.metaContactToLeadSuccess,
    metaContactToLeadError: state.appIntegrations.metaContactToLeadError,

    deleteMetaAccountSuccess: state.appIntegrations.deleteMetaAccountSuccess,
    deleteMetaAccountLoading: state.appIntegrations.deleteMetaAccountLoading,
    metaAccountId: state.appIntegrations.metaAccountId,
    streamStatusSuccess: state.appIntegrations.streamStatusSuccess,
    streamStatusLoading: state.appIntegrations.streamStatusLoading,

    metaContact_listLoading: state.appIntegrations.metaContact_listLoading,
    metaContact_listSuccess: state.appIntegrations.metaContact_listSuccess,
    metaContact_list: state.appIntegrations.metaContact_list,

    deleteStreamSuccess: state.appIntegrations.deleteStreamSuccess,
    deleteStreamLoading: state.appIntegrations.deleteStreamLoading,
    edufinConnectLoading: state.appIntegrations.edufinConnectLoading,
    edufinConnectSuccess: state.appIntegrations.edufinConnectSuccess,
    edufinConnectError: state.appIntegrations.edufinConnectError,
    edufinDataLoading: state.appIntegrations.edufinDataLoading,
    edufinDataSuccess: state.appIntegrations.edufinDataSuccess,
    edufinDataError: state.appIntegrations.edufinDataError,
    edufinData: state.appIntegrations.edufinData,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    ConnectOzonetel: (data: ConnectOzonetelDTO) => {
      dispatch(connectOzonetel(data));
    },
    GetStaffList: (id: string) => {
      dispatch(getStaffList(id));
    },
    GetInstituteById: (id: string) => {
      dispatch(getInstituteById(id));
    },
    DeactivateOzonetel: (id: string) => {
      dispatch(deactivateOzonetel(id));
    },
    ValidateAgentId: (data: any) => {
      dispatch(validateAgentId(data));
    },
    GetAppsByInstitute: (id: string) => {
      dispatch(getAppsByInstitute(id));
    },
    AddOzonetelAgents: (data: any) => {
      dispatch(addOzonetelAgents(data));
    },
    CallLead: (data: any) => {
      dispatch(callLead(data));
    },
  };
};

export interface OzonetelStagesProps
  extends IntegrationsInitialStateDTO,
    DispatchProps {}
export const OzontelStagesComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(OzonetelStages);
